import { useState, useEffect } from "react";
import { Helmet } from "react-helmet"
import { useTranslation } from 'react-i18next';

import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import ca from 'date-fns/locale/ca';
import fr from 'date-fns/locale/fr';
import de from 'date-fns/locale/de';
import pt from 'date-fns/locale/pt';
import ru from 'date-fns/locale/ru';

import axios from 'axios';

import LangSelector, { langSelector } from '../Compartido/LangSelector.jsx';

const stripHtml = (html) => {
    return html.replace(/<[^>]*>/g, '');
};

const HeaderProp = ({ config, lang, meta_descripcion, meta_keywords, meta_titulo, ruta, idiomas, propiedad, destino, destinos, experiencias, comentarios }) => {

    const { t } = useTranslation();

    if (lang == "es")
        registerLocale('es', es)
    else if (lang == "fr")
        registerLocale('fr', fr)
    else if (lang == "ca")
        registerLocale('ca', ca)
    else if (lang == "de")
        registerLocale('de', de)
    else if (lang == "pt")
        registerLocale('pt', pt)
    else if (lang == "ru")
        registerLocale('ru', ru)
    else
        registerLocale('es', es)


    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [emailcliente, setEmailCliente] = useState(null);

    const handleStartDate = (date) => {
        setStartDate(date);

        if (date) {
            const minEnd = new Date(date);
            minEnd.setDate(minEnd.getDate() + 1);

            // Si la salida no existe o queda antes del mínimo permitido
            if (!endDate || endDate < minEnd) {
                setEndDate(minEnd);
            }
        } else {
            setEndDate(null);
        }
    };

    const [cMeses, setCMeses] = useState(1);

    const handleSubmitBusca = async (e) => {
        e.preventDefault()

        let token = document.getElementById('meta_token').getAttribute('content');

        try {
            const result = await axios.post('/buscar-reservas-cliente', {
                finicio: startDate,
                ffinal: endDate,
                email: emailcliente
            }, {
                headers: {
                    'content-type': 'application/json',
                    'X-CSRF-TOKEN': token
                }
            });

            if (result.data.Error === "OK") {
                console.log("ok");
                console.log(result.data.reservas.length);


            } else {
                console.log("error");
            }
        } catch (err) {
            console.error(err);
        }
    };

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    useEffect(() => {
        if (config.css_personalizado) {
            const linkElement = document.createElement('link');
            linkElement.rel = 'stylesheet';
            linkElement.type = 'text/css';
            linkElement.href = config.css_personalizado;
            const headElement = document.head;
            headElement.appendChild(linkElement);
        }

    }, []);

    const descripcionLimpia = meta_descripcion ? stripHtml(meta_descripcion) : "";
    const keywordsLimpias = meta_keywords ? stripHtml(meta_keywords) : "";


    const [activeHoteles, setActiveHoteles] = useState("");
    const [activeOfertas, setActiveOfertas] = useState("");
    const [activeMas, setActiveMas] = useState("");

    const [activeMisReservas, setActiveMisReservas] = useState("");
    const [activeLogin, setActiveLogin] = useState("");
    const [activePhones, setActivePhones] = useState("");

    const [activeLoginado, setActiveLoginado] = useState("");

    function changeShowLoginado() {
        setActiveLoginado(prev => prev === "show" ? "" : "show");
        setActiveMisReservas("");
        setActiveHoteles("");
        setActiveOfertas("");
        setActiveMas("");
        setActiveLogin("");
        setActivePhones("");
    }

    function changeShowPhones() {
        setActivePhones(prev => prev === "show" ? "" : "show");
        setActiveLogin("");
        setActiveMisReservas("");
        setActiveHoteles("");
        setActiveOfertas("");
        setActiveMas("");
    }

    function changeShowLogin() {
        setActiveLogin(prev => prev === "show" ? "" : "show");
        setActiveMisReservas("");
        setActiveHoteles("");
        setActiveOfertas("");
        setActiveMas("");
        setActivePhones("");
    }

    function changeShowMisReservas() {
        setActiveMisReservas(prev => prev === "show" ? "" : "show");
        setActiveHoteles("");
        setActiveOfertas("");
        setActiveMas("");
        setActiveLogin("");
        setActivePhones("");
    }

    function changeShowHoteles() {
        setActiveHoteles(prev => prev === "show" ? "" : "show");
        setActiveOfertas("");
        setActiveMas("");
        setActiveMisReservas("");
        setActiveLogin("");
        setActivePhones("");
    }

    function changeShowOfertas() {
        setActiveOfertas(prev => prev === "show" ? "" : "show");
        setActiveHoteles("");
        setActiveMas("");
        setActiveMisReservas("");
        setActiveLogin("");
        setActivePhones("");
    }

    function changeShowMas() {
        setActiveMas(prev => prev === "show" ? "" : "show");
        setActiveHoteles("");
        setActiveOfertas("");
        setActiveMisReservas("");
        setActiveLogin("");
        setActivePhones("");
    }

    function getArrayCookie(nombre) {
        let nombreCookie = `${nombre}=`;
        let cookiesDecodificadas = decodeURIComponent(document.cookie);
        let arrayCookies = cookiesDecodificadas.split(';');

        for (let i = 0; i < arrayCookies.length; i++) {
            let cookie = arrayCookies[i].trim();
            if (cookie.indexOf(nombreCookie) === 0) {
                try {
                    return JSON.parse(cookie.substring(nombreCookie.length, cookie.length));
                } catch (e) {
                    console.error('Error parseando cookie:', e);
                    return null;
                }
            }
        }
        return null;
    }

    const cookieValue = getArrayCookie("datos");

    return (
        <>
            <Helmet>
                <title>{`${meta_titulo}`}</title>
                <meta name="title" content={`${meta_titulo}`} />
                <meta name="description" content={descripcionLimpia} />
                <meta name="keywords" content={keywordsLimpias} />
                <meta charset="utf-8" />
            </Helmet>

            <Helmet>
                <link rel="stylesheet" href={"/css/web/valesuites/styles_vale.css"} media="screen" />
            </Helmet>

            {
                (config.id === 1) ?
                    <Helmet>
                        <link rel="icon" type="image/x-icon" href={`${ruta}/web/favicon/favicon.ico`}></link>
                    </Helmet>
                    :
                    <Helmet>
                        <link rel="icon" type="image/x-icon" href={`${ruta}/web/favicon/${config.id}/favicon.ico`}></link>
                    </Helmet>
            }

            {
                (config.activa_analytics === 1) ?
                    <Helmet>
                        <script>
                            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${config.codigo_analytics}');
                                    `}
                        </script>
                    </Helmet>
                    :
                    ""
            }

            {
                (config.activa_analytics === 1) ?
                    <noscript>
                        {`<iframe src="https://www.googletagmanager.com/ns.html?id=${config.codigo_analytics}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`}
                    </noscript>
                    :
                    ""
            }

            {/* ******* */}
            <header >
                <header className="header header-hotel">
                    <div className="header_container">
                        <div className="header__wrapper">
                            <div className="header__brand g-brand">
                                <div className="header__mobile-inner">
                                    <button type="button" className="btn btn-icon header__mobile-bars">
                                        <span className="visually-hidden">Menú</span>
                                        <span className="icon-bars">
                                            <span ></span>
                                            <span ></span>
                                            <span ></span>
                                        </span>
                                    </button>
                                    <a className="header__brand-link" href={"/" + preidioma}>
                                        {
                                            config.logo !== "" ?
                                                <img className="header__brand-logo" alt="Logo" title="Logo" src={ruta + "/web/logo/web/" + config.logo} />
                                                :
                                                config.logo_fiscal != "" ?
                                                    <img className="header__brand-logo" alt="Logo" title="Logo" src={ruta + "/web/logo/" + config.logo_fiscal} />
                                                    :
                                                    <img className="header__brand-logo" alt="Logo BedLoop" title="Logo BedLoop" src="https://www.bedloop.com/imatges/logo.webp" />
                                        }
                                    </a>
                                    <app-hotel-bread-crumb-h10 >
                                        <ul className="list-unstyled header-hotel_breadcrumb d-none d-md-flex">
                                            <li>
                                                <a href={"/" + preidioma}>{t("Inicio")}</a>
                                            </li>
                                            <li>
                                                <a href={"/" + preidioma + propiedad.destino.url_dinamica[lang]}>{propiedad.destino.nombre[lang]} </a>
                                            </li>
                                        </ul>
                                    </app-hotel-bread-crumb-h10>


                                </div>
                            </div>
                            <div className="header__top g-top">
                                <language-dropdown >
                                    <LangSelector
                                        idiomas={idiomas}
                                        langactual={lang.toString().toUpperCase()}
                                        color="black"
                                    />
                                </language-dropdown>
                                <manage-booking-dropdown >
                                    <div ngbdropdown="" utoclose="outside" className="header__booking o-dropdown btn-group o-separador dropdown">
                                        <button id="btnMisReservas" type="button" ngbdropdowntoggle="" className="dropdown-toggle btn btn-basic o-dropdown__btn d-none d-md-block" aria-expanded="false" onClick={() => changeShowMisReservas()}>{t("MIS RESERVAS")}</button>
                                        <div ngbdropdownmenu="" id="myDropdown" aria-labelledby="btnMisReservas" className={`overflow-visible dropdown-menu o-dropdown__menu ${activeMisReservas === 'show' ? 'show' : ''} `}>
                                            <div className="o-dropdown-content">
                                                <div className="o-dropdown-header">
                                                    <p className="o-dropdown-header-title"> {t("MIS RESERVAS")} </p>
                                                    <button type="button" className="btn btn-close">
                                                        <span className="visually-hidden">{t("Cerrar")}</span>
                                                    </button>
                                                </div>
                                                <div className="o-dropdown-body">
                                                    <p className="header__booking-title">{t("GESTIONA TU RESERVA")}</p>
                                                    <div className="header__booking-wrapper">
                                                        <form noValidate="" className="header__booking-form ng-untouched ng-pristine ng-invalid" onSubmit={handleSubmitBusca}>
                                                            <div className="gap-2 mb-2 d-flex flex-column flex-md-row gap-md-1">
                                                                <div className="form-input required">
                                                                    <label className="form-label">{t("FECHA ENTRADA")}</label>
                                                                    <DatePicker
                                                                        selected={startDate}
                                                                        onChange={handleStartDate}
                                                                        selectsStart
                                                                        isClearable={true}
                                                                        className="form-control cpointer noborder fs15"
                                                                        autoComplete="off"
                                                                        startDate={startDate}
                                                                        endDate={endDate}
                                                                        monthsShown={cMeses}
                                                                        dateFormat="dd/MM/yyyy"
                                                                        minDate={new Date()}
                                                                        placeholderText={t("DD/MM/YYYY")}
                                                                        locale={lang}
                                                                        name="finicio"
                                                                        required
                                                                    >
                                                                    </DatePicker>
                                                                </div>
                                                                <div className="form-input required">
                                                                    <label className="form-label">{t("FECHA SALIDA")}</label>
                                                                    <DatePicker
                                                                        selected={endDate}
                                                                        onChange={setEndDate}
                                                                        selectsEnd
                                                                        isClearable={true}
                                                                        className="form-control cpointer noborder fs15"
                                                                        autoComplete="off"
                                                                        monthsShown={cMeses}
                                                                        startDate={startDate}
                                                                        endDate={endDate}
                                                                        dateFormat="dd/MM/yyyy"
                                                                        minDate={
                                                                            startDate
                                                                                ? new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1)
                                                                                : new Date()
                                                                        }
                                                                        placeholderText={t("DD/MM/YYYY")}
                                                                        locale={lang}
                                                                        name="ffinal"
                                                                    >
                                                                    </DatePicker>
                                                                </div>
                                                            </div>
                                                            <div className="mb-3">
                                                                <label htmlFor="controlEmail" className="form-label">{t("E-MAIL")}</label>
                                                                <input formcontrolname="email" type="email" data-qm-encrypt="true" data-tag-id="mres_sfo_in_mail" className="form-control ng-untouched ng-pristine ng-invalid" placeholder={t("Escribe tu email")} name="email" required onChange={(e) => setEmailCliente(e.target.value)} />
                                                            </div>
                                                            <button type="submit" data-tag-id="mres_sfo_bt_sch" className="btn btn-primary">{t("BUSCAR RESERVA")}</button>
                                                        </form>
                                                        <div className="header__booking-content">
                                                            <div>
                                                                <label className="localizador-label title form-label">{t("CHECK-IN ONLINE")}</label>
                                                                <p>{t("Desde las 15h, dos días antes de tu llegada.")}</p>
                                                                <div className="d-flex flex-column">
                                                                    <div className="mb-0 d-flex cont-select gap-md-1">
                                                                        <ng-select data-tag-id="mres_cin_sel_h" bindlabel="name" className="ng-select ng-select-single ng-untouched ng-pristine ng-valid">
                                                                            <div className="ng-select-container">
                                                                                <div className="ng-value-container">

                                                                                    <div className="ng-placeholder">{t("Selecciona tu hotel")}</div>

                                                                                    <div className="ng-input">
                                                                                        <input aria-autocomplete="list" role="combobox" type="text" autoCorrect="off" autoCapitalize="none" autoComplete="a4c494b166e8" readOnly="" aria-expanded="false" />
                                                                                    </div>
                                                                                </div>


                                                                                <span className="ng-arrow-wrapper">
                                                                                    <span className="ng-arrow"></span>
                                                                                </span>
                                                                            </div>

                                                                        </ng-select>

                                                                    </div>
                                                                    <a target="_blank" href="">
                                                                        <button type="button" data-tag-id="mres_cin_bt_start" className="btn btn-primary disabled-link"> {t("CHECK-IN ONLINE")} <i className="fa-solid fa-arrow-right-to-bracket"></i>
                                                                        </button>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <label className="localizador-label title form-label">{t("CHECK-OUT ONLINE")}</label>
                                                                <p>{t("Desde las 22h del día anterior a tu salida.")}</p>
                                                                <a data-tag-id="mres_cout_bt_start" target="_blank" className="btn btn-primary" href="#"> {t("CHECK-OUT ONLINE")} <i className="fa-solid fa-arrow-right-from-bracket"></i>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </manage-booking-dropdown>
                                <phone-list-dropdown >
                                    <div autoclose="outside" className="header__csupp o-dropdown btn-group o-separador dropdown">
                                        <button data-tag-id="hdr_con_lk_open" type="button" ngbdropdowntoggle="" className="dropdown-toggle btn btn-basic btn-mov o-dropdown__btn" aria-expanded="false" onClick={() => changeShowPhones()}>
                                            <span className="header__mobile-icon d-md-none">
                                                <i className="fa-solid fa-phone"></i>
                                            </span>
                                            <span className="d-none d-md-block">{config.telefono_fiscal}</span>
                                        </button>
                                        <div ngbdropdownmenu="" aria-labelledby="hdr_con_lk_open" className={`dropdown-menu o-dropdown__menu o-dropdown-bg-white ${activePhones === 'show' ? 'show' : ''}`}>
                                            <div className="o-dropdown-content">
                                                <div className="o-dropdown-header">
                                                    <p className="o-dropdown-header-title">{t("CONTÁCTANOS")} </p>
                                                    <button type="button" ngbdropdowntoggle="" className="dropdown-toggle btn btn-icon btn-close" aria-expanded="false">
                                                        <span className="visually-hidden">{t("Cerrar")}</span>
                                                        <span className="o-dropdown-header-icon">
                                                            <i className="fa-solid fa-xmark"></i>
                                                        </span>
                                                    </button>
                                                </div>
                                                <div className="o-dropdown-body">
                                                    <ul className="p-0 m-0 o-dropdown__links">
                                                        <li className="flex-row gap-1 mb-4 align-items-center">
                                                            <span className="o-icon">
                                                                <i className="fa-sharp fa-solid fa-phone"></i>
                                                            </span>
                                                            <span>{t("Atención al Cliente")}</span>
                                                        </li>
                                                        <li className="mb-3">
                                                            <button type="button" data-tag-id="hdr_con_bt_rcall" className="btn btn-primary"> {t("Te llamamos gratis")} </button>
                                                        </li>

                                                        <li>
                                                            <a href={`tel:${config.telefono_fiscal}`} data-tag-id="hdr_con_ph_0">
                                                                <span className="text-uppercase">{t("España")}</span>
                                                                <strong>{config.telefono_fiscal}</strong>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </phone-list-dropdown>
                                <login-dropdown >
                                    <div autoclose="outside" placement="bottom-end" className="o-dropdown header__login dropdown">

                                        {
                                            cookieValue ?
                                                <>
                                                    <button type="button" className="dropdown-toggle btn-mov btn btn-logeado" aria-expanded="false" onClick={() => changeShowLoginado()}>
                                                        <strong className="d-none d-md-inline">{cookieValue.nombre + " " + cookieValue.apellidos}</strong>{" "}
                                                        <i className="fa-sharp fa-solid fa-chevron-down" style={{ fontSize: "16px", paddingRight: "10px" }}></i>
                                                    </button>
                                                    <div id="collapseLogeado" className="rw-drop-login collapse show" style={{ display: activeLoginado === 'show' ? 'block' : 'none' }}>
                                                        <div className="rw-drop-login_content">
                                                            <button type="button" className="btn btn-close d-md-none"></button>
                                                            <div className="rw-drop-login_header">
                                                                <figure>
                                                                    <img loading="lazy" alt="" src="https://pro-static.h10hotels.com/templates/H10/src/images/user.png" />
                                                                </figure>
                                                                <p className="mb-0">HOLA, <br />
                                                                    <span className="name">
                                                                        <strong>{cookieValue.nombre}</strong>
                                                                    </span>
                                                                </p>
                                                            </div>
                                                            <div className="rw-drop-login_body bg-essential">
                                                                <p className="categoria">{t("CATEGORÍA")} <br />
                                                                    <span>ESSENTIAL</span>
                                                                </p>
                                                                <ul>
                                                                    <li>
                                                                        <img alt="" loading="lazy" className="icon" src="https://pro-static.h10hotels.com/templates/H10/src/icons/small-card.svg" />
                                                                        <span>{t("TARJETA DE SOCIO")} <br />
                                                                            <strong>{cookieValue.id}</strong>
                                                                        </span>
                                                                    </li>
                                                                    <li>
                                                                        <img alt="" loading="lazy" className="icon" src="https://pro-static.h10hotels.com/templates/H10/src/icons/star-white.svg" />
                                                                        <span>{t("MIS PUNTOS")} <br />
                                                                            <strong>100</strong>
                                                                        </span>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                            <div className="rw-drop-login_footer">
                                                                <a data-tag="log_pst_bt_acc" className="btn nohover rw-btn btn-outline-dark" href={`/${preidioma}${t("mi-cuenta")}`} style={{ borderRadius: "41.6px" }}>
                                                                    <img alt="" loading="lazy" className="icon" src="https://pro-static.h10hotels.com/templates/H10/src/icons/user-icon.svg" />
                                                                    <span>{t("MI CUENTA")}</span>
                                                                </a>
                                                                <a data-tag="log_pst_bt_rew" className="btn nohover rw-btn btn-outline-dark" href={`/${preidioma}${t("rewards")}`} style={{ borderRadius: "41.6px" }}>
                                                                    <img alt="" loading="lazy" className="icon" src="https://pro-static.h10hotels.com/templates/H10/src/icons/icon-rewards.svg" />
                                                                    <span>{t("VALE REWARDS")}</span>
                                                                </a>
                                                                <button type="button" data-tag="log_pst_bt_out" className="btn rw-btn btn-dark" style={{ borderRadius: "41.6px" }} onClick={() => borrarCookie("datos")}> {t("Cerrar sesión")} </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <button type="button" aria-expanded="false" id="login_btn_open" className="btn btn-mov btn-login" onClick={() => changeShowLogin()}>

                                                        <i className="fa-sharp fa-solid fa-circle-user" style={{ fontSize: "16px", paddingRight: "10px" }}></i>

                                                        <span className="d-none d-md-inline">{t("INICIAR SESION")}</span>
                                                    </button>

                                                    <div className={`o-dropdown__menu dropdown-menu rw-drop-logout collapse ${activeLogin === 'show' ? 'show' : ''}`}>
                                                        <div className="rw-drop-logout_content">
                                                            <button type="button" className="btn btn-close d-md-none"></button>
                                                            <div className="rw-drop-logout_info d-none d-md-flex">
                                                                <figure className="mb-0 info-img d-none d-xl-flex">
                                                                    {/* <img loading="lazy" src="https://pro-static.h10hotels.com/gallery/T11D3/H10Rewards_APriv_Desplegable.jpg" alt="" />*/}
                                                                    <img loading="lazy" src="/images/web/valesuites/parejadepie.png" alt="" />
                                                                </figure>
                                                                <div className="info-content">
                                                                    <div className="d-flex info-header">
                                                                        <figure>
                                                                            {
                                                                                config.logo !== "" ?
                                                                                    <img loading="lazy" className="logo" alt="Logo" title="Logo" src={ruta + "/web/logo/web/" + config.logo} />
                                                                                    :
                                                                                    config.logo_fiscal != "" ?
                                                                                        <img loading="lazy" className="logo" alt="Logo" title="Logo" src={ruta + "/web/logo/" + config.logo_fiscal} />
                                                                                        :
                                                                                        <img loading="lazy" className="logo" alt="Logo BedLoop" title="Logo BedLoop" src="https://www.bedloop.com/imatges/logo.webp" />
                                                                            }
                                                                        </figure>
                                                                        <div>
                                                                            <p className="mb-2 h4 h4-rewards mb-xxl-4">
                                                                                <span>{t("DONDE SIEMPRE ERES BIENVENIDO")}</span>
                                                                            </p>
                                                                            <p>{t("Nuestro programa de fidelización te abre las puertas a un mundo de ventajas, descuentos directos y trato exclusivo para que disfrutes de tus estancias.")}</p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex info-body">
                                                                        <div className="info-body_item">
                                                                            <figure>
                                                                                <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_DESCUENTO_Negro.svg" alt="" />
                                                                            </figure>
                                                                            <p>{t("Disfruta de mínimo un 5% de descuento en todas las reservas en nuestra web")}</p>
                                                                        </div>
                                                                        <div className="info-body_item">
                                                                            <figure>
                                                                                <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_PRIMIUM_Negro.svg" alt="" />
                                                                            </figure>
                                                                            <p>{t("Accede a ofertas solo para socios y reserva con las mejores condiciones")}</p>
                                                                        </div>
                                                                        <div className="info-body_item">
                                                                            <figure>
                                                                                <img loading="lazy" className="icon" src="https://pro-static.h10hotels.com/gallery/H10Rewards_Icono_REGALO_Negro.svg" alt="" />
                                                                            </figure>
                                                                            <p>{t("Siéntete especial durante tu estancia")}</p>
                                                                        </div>

                                                                    </div>

                                                                    <div className="d-flex align-items-xxl-center info-footer flex-xxl-row">
                                                                        <p>
                                                                            {t("Y muchas más ventajas...")} <span style={{ color: "rgb(150, 113, 38)" }}>{t("¡Descúbrelas!")}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="rw-drop-logout_form">
                                                                <figure className="mb-0 rw-drop-logout_logo">
                                                                    <img loading="lazy" alt="Logo rewards" className="d-md-none" src="https://pro-static.h10hotels.com/templates/H10/src/images/logo-rewards-black.png" />
                                                                </figure>
                                                                <form noValidate="" className="form-login ng-untouched ng-pristine ng-valid">
                                                                    <div className="row-gap-2 mb-3 d-flex justify-content-between column-gap-2 column-gap-md-3 column-gap-xxl-4">
                                                                        <p className="text-center title d-none d-md-inline">
                                                                            <strong>{t("LOGIN VALE REWARDS")}</strong>
                                                                        </p>
                                                                    </div>
                                                                    <p>{t("Si ya estás registrado...")}</p>
                                                                    <div className="flex-wrap gap-3 d-flex flex-xxs-nowrap justify-content-between align-items-center">
                                                                        <a type="submit" className="mx-auto btn rw-btn btn-rewards mx-xs-0" style={{ width: "100%" }} href={`/${preidioma}${t("loginweb")}`}> {t("ACCEDER")} </a>
                                                                    </div>
                                                                    <div className="rw-drop-logout_form-btns border-bottom"></div>
                                                                    <p className="mb-3 text-center">
                                                                        <strong>{t("¿Aún no tienes acceso online?")}</strong>
                                                                    </p>
                                                                    <a type="button" className="mx-auto btn rw-btn btn-outline-rewards fw-semibold d-flex w-fit text-rewards" href={`/${preidioma}${t("altasocio")}`}>{t("CREAR CUENTA")}</a>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                        }

                                    </div>
                                </login-dropdown>
                            </div>
                            <div className="header__menu g-menu">
                                <nav className="header__navbar">
                                    <ul className="header__navbar-nav">
                                        <li>
                                            <button type="button" data-tag-id="nav_lk_hot" ngbdropdowntoggle="" className="dropdown-toggle link" aria-expanded="false" onClick={() => changeShowHoteles()}>{t("DESTINOS")} <span className="d-md-none o-icon" >
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                            </button>
                                            <div ngbdropdownmenu="" aria-labelledby="nav_lk_hot" className={`dropdown-menu header_dropdown-columns ${activeHoteles === 'show' ? 'show' : ''}`}>
                                                <div className="col-md-7 pe-md-4">
                                                    <div >
                                                        <div className="header_dropdown-columns_title">
                                                            <button type="button" className="btn btn-back d-sm-none">
                                                                <span className="visually-hidden">{t("Cerrar")}</span>
                                                                <span className="o-icon o-icon-1">
                                                                    <i className="fa-solid fa-chevron-left"></i>
                                                                </span>
                                                            </button>
                                                            <p >{t("DESTINOS")} </p>
                                                            <button type="button" className="btn btn-close d-none d-sm-block d-md-none ms-auto">
                                                                <span className="visually-hidden">{t("Cerrar")}</span>
                                                            </button>
                                                        </div>
                                                        <div ngbaccordion="" className="accordion">
                                                            <div ngbaccordionitem="" className="accordion-item" id="ngb-accordion-item-2">
                                                                <div role="heading" ngbaccordionheader="" className="accordion-header collapsed">
                                                                    <button type="button" ngbaccordionbutton="" className="accordion-button collapsed" id="ngb-accordion-item-2-toggle" aria-controls="ngb-accordion-item-2-collapse" aria-expanded="false">{t("España")}</button>
                                                                </div>
                                                                <div role="region" ngbaccordioncollapse="" className="accordion-collapse collapse" id="ngb-accordion-item-2-collapse" aria-labelledby="ngb-accordion-item-2-toggle">
                                                                    <div ngbaccordionbody="" className="accordion-body">
                                                                        <ul className="break-list">
                                                                            {destinos.map((undestino, index) => (
                                                                                <li key={index}>
                                                                                    <a href={"/" + preidioma + t("buscar") + "?destino=" + undestino.laurl}> {undestino.elnombre}
                                                                                    </a>
                                                                                </li>
                                                                            ))
                                                                            }
                                                                        </ul>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>
                                                    <div className="border-top">
                                                        <a className="btn btn-primary" href="#"> {t("VER TODOS LOS DESTINOS")}
                                                            <span className="o-icon d-md none">
                                                                <i className="fa-solid fa-arrow-right"></i>
                                                            </span>
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    {
                                                        experiencias.length > 0 ?
                                                            <>
                                                                <div className="header_dropdown-columns_title">
                                                                    <p >{t("EXPERIENCIAS")}</p>
                                                                </div>
                                                                <ul className="header_overflow header_list-img">
                                                                    {
                                                                        experiencias.map((unaexperiencia, index) => (
                                                                            <li key={index}>
                                                                                <a href={"/" + preidioma + t("experiencias") + "/" + unaexperiencia.url_dinamica[lang]}>
                                                                                    <figure className="d-none d-md-block">
                                                                                        {unaexperiencia.imagen ?
                                                                                            <img src={`${ruta}/experiencias/${unaexperiencia.id}/${unaexperiencia.imagen}`} className="o-cover" />
                                                                                            :
                                                                                            <img src="/images/web/bedloop-nofoto.png" className="o-cover" />
                                                                                        }
                                                                                    </figure>
                                                                                    <span >
                                                                                        <strong >{unaexperiencia.nombre[lang]}</strong>
                                                                                        <br />
                                                                                        <span className="d-none d-md-block" dangerouslySetInnerHTML={{ __html: unaexperiencia.texto[lang] }}>
                                                                                        </span>
                                                                                        <span className="btn btn-link d-none d-md-flex"> {t("MÁS INFO")} <i className="fa-solid fa-arrow-right"></i>
                                                                                        </span>
                                                                                    </span>
                                                                                </a>
                                                                            </li>
                                                                        ))
                                                                    }
                                                                </ul>

                                                            </>
                                                            :
                                                            ""
                                                    }
                                                </div>
                                            </div>
                                        </li>
                                        {/*
                                        <li>
                                            <button type="button" data-tag-id="nav_lk_off" ngbdropdowntoggle="" className="dropdown-toggle link" aria-expanded="false" onClick={() => changeShowOfertas()}>{t("OFERTAS")} <span className="d-md-none o-icon">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                            </button>
                                            <div ngbdropdownmenu="" aria-labelledby="nav_lk_off" className={`dropdown-menu header_dropdown-columns header-dropdown_ofertas ${activeOfertas === 'show' ? 'show' : ''}`}>
                                                <div className="col-md-6 pe-md-4 pe-lg-5">
                                                    <div >
                                                        <div className="header_dropdown-columns_title d-md-none">
                                                            <button type="button" className="btn btn-back d-sm-none">
                                                                <span className="visually-hidden">{t("Cerrar")}</span>
                                                                <span className="o-icon o-icon-1">
                                                                    <i className="fa-solid fa-chevron-left"></i>
                                                                </span>
                                                            </button>
                                                            <p >{t("OFERTAS")}</p>
                                                            <button type="button" className="btn btn-close d-none d-sm-block d-md-none ms-auto">
                                                                <span className="visually-hidden">{t("Cerrar")}</span>
                                                            </button>
                                                        </div>
                                                        <div className="header_dropdown-columns_title">

                                                            <p className="mb-2">{t("OFERTAS")}</p>

                                                        </div>
                                                        <ul className="header_overflow header_list-img">
                                                            <li >
                                                                <a >
                                                                    <figure className="d-none d-md-block">
                                                                        <img src="https://pro-static.h10hotels.com/gallery/T1D3/29_ORPSwimUpBar1.jpg" alt="Swim Up Bar" />
                                                                    </figure>
                                                                    <span >
                                                                        <strong >{t("Hoy comienza el verano de sus vidas")}</strong>
                                                                        <br />
                                                                        <span className="d-none d-md-block">
                                                                            <p>{t("Vacaciones en familia con hasta un 25% de descuento. Código: KIDS26")}</p>
                                                                        </span>
                                                                        <span className="btn btn-link d-none d-md-flex">
                                                                            <a href={"/" + preidioma + t("ofertas")}>{t("VER MÁS")}</a>
                                                                            <span className="o-icon arrow">
                                                                                <i className="fa-solid fa-arrow-right"></i>
                                                                            </span>
                                                                        </span>
                                                                    </span>
                                                                </a>
                                                            </li>

                                                            <li >
                                                                <a >
                                                                    <figure className="d-none d-md-block">
                                                                        <img src="https://pro-static.h10hotels.com/gallery/T1D3/31_HESPanoramicView.jpg" alt="Vista panorámica del hotel frente al mar" />
                                                                    </figure>
                                                                    <span >
                                                                        <strong >{t("Escápate al sol de primavera")}</strong>
                                                                        <br />
                                                                        <span className="d-none d-md-block">
                                                                            <p>{t("Viaja esta temporada con hasta un 20% de descuento. Código: SPRING26")}</p>
                                                                        </span>
                                                                        <span className="btn btn-link d-none d-md-flex">
                                                                            <a href={"/" + preidioma + t("ofertas")}>{t("VER MÁS")}</a>
                                                                            <span className="o-icon arrow">
                                                                                <i className="fa-solid fa-arrow-right"></i>
                                                                            </span>
                                                                        </span>
                                                                    </span>
                                                                </a>
                                                            </li>

                                                            <li >
                                                                <a >
                                                                    <figure className="d-none d-md-block">
                                                                        <img src="https://pro-static.h10hotels.com/gallery/T1D3/07.1_HMVHotelPool.jpg" alt="Piscina" />
                                                                    </figure>
                                                                    <span >
                                                                        <strong >{t("Salou y Cambrils: la esencia mediterránea")}</strong>
                                                                        <br />
                                                                        <span className="d-none d-md-block">
                                                                            <p>{t("Hasta -25% y vermut con chips para saborear tus vacaciones de verano. Código: DORADA26")}</p>
                                                                        </span>
                                                                        <span className="btn btn-link d-none d-md-flex">
                                                                            <a href={"/" + preidioma + t("ofertas")}>{t("VER MÁS")}</a>
                                                                            <span className="o-icon arrow">
                                                                                <i className="fa-solid fa-arrow-right"></i>
                                                                            </span>
                                                                        </span>
                                                                    </span>
                                                                </a>
                                                            </li>


                                                        </ul>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 ps-lg-5">
                                                    <div className="header_dropdown-columns_title">
                                                        <p className="mb-2">{t("EXPLORA")}</p>
                                                    </div>
                                                    <ul className="header_overflow header_list-img">
                                                        {destinos.map((undestino, index) => (
                                                            <li key={index}>
                                                                <a >
                                                                    <figure className="d-none d-md-block">
                                                                        {undestino.imagen_principal.length > 0 ?
                                                                            <img src={`${ruta}/destinos/${undestino.id}/${undestino.imagen_principal[0].imagen}`} alt="" />
                                                                            :
                                                                            <img src="/images/web/bedloop-nofoto.png" alt="" />
                                                                        }
                                                                    </figure>
                                                                    <span >
                                                                        <strong>{undestino.elnombre}</strong>
                                                                        <br />
                                                                        <span >
                                                                            < p>{t("Desde 185€/noche")}</p>
                                                                        </span>
                                                                        <span className="btn btn-link d-none d-md-flex">
                                                                            <a href={"/" + preidioma + t("ofertas")}>{t("VER MÁS")}</a>
                                                                            <span className="o-icon arrow">
                                                                                <i className="fa-solid fa-arrow-right"></i>
                                                                            </span>
                                                                        </span>
                                                                    </span>
                                                                </a>
                                                            </li>

                                                        ))
                                                        }
                                                    </ul>
                                                </div>
                                                <div className="mt-3 border-top">
                                                    <a className="btn btn-primary" href={"/" + preidioma + t("ofertas")}> {t("VER TODAS LAS OFERTAS")} <span className="o-icon d-md-none">
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </span>
                                                    </a>
                                                </div>
                                            </div>
                                        </li>
                                        */}
                                        {/* <li >
                                            <a data-tag-id="nav_lk_evt" className="link" href={"/" + preidioma + t("eventos")} > {t("EVENTOS")} <span className="d-md-none o-icon">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                            </a>
                                        </li>*/}
                                        <li >
                                            <a data-tag-id="nav_lk_c10" className="link" href="#">{t("REWARDS")} <span className="d-md-none o-icon">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                            </a>
                                        </li>
                                        <li>
                                            <button type="button" data-tag-id="nav_lk_more" ngbdropdowntoggle="" className="dropdown-toggle link" aria-expanded="false" onClick={() => changeShowMas()}>{t("MÁS...")}<span className="d-md-none o-icon">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                            </button>
                                            <div ngbdropdownmenu="" aria-labelledby="nav_lk_more" className={`dropdown-menu header_dropdown-more ${activeMas === 'show' ? 'show' : ''}`}>
                                                <button type="button" className="btn btn-close d-none d-sm-block d-md-none ms-auto">
                                                    <span className="visually-hidden">{t("Cerrar")}</span>
                                                </button>
                                                <div className="header_dropdown-columns_title d-sm-none">
                                                    <button type="button" className="btn btn-back d-sm-none">
                                                        <span className="visually-hidden">{t("Cerrar")}</span>
                                                        <span className="o-icon o-icon-1">
                                                            <i className="fa-solid fa-chevron-right"></i>
                                                        </span>
                                                    </button>
                                                    <p >{t("MÁS...")}</p>
                                                </div>
                                                <ul >
                                                    <li >
                                                        {/* <a href=""></a>*/}
                                                    </li>
                                                    <li >
                                                        {/* <a href=""></a>*/}
                                                    </li>

                                                </ul>
                                            </div>
                                        </li>
                                        <li className="d-md-none">
                                            <button className="btn link">{t("MIS RESERVAS")} <span className="d-md-none o-icon">
                                                <i className="fa-solid fa-chevron-right"></i>
                                            </span>
                                            </button>
                                        </li>
                                        <li className="d-none d-md-searchout-block ms-3 header_btn-buscar">
                                            <button type="button" className="btn btn-primary btn-md"> {t("Buscar")} </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <app-hotel-top >
                            <div className="header-hotel_info">
                                <div className="container">
                                    <div className="header-hotel_info-hotel">
                                        <a className="header-hotel_info-hotel_logo d-none d-md-block" href={"/" + preidioma}>
                                            {
                                                config.logo !== "" ?
                                                    <img alt="Logo" title="Logo" src={ruta + "/web/logo/web/" + config.logo} />
                                                    :
                                                    config.logo_fiscal != "" ?
                                                        <img alt="Logo" title="Logo" src={ruta + "/web/logo/" + config.logo_fiscal} />
                                                        :
                                                        <img alt="Logo BedLoop" title="Logo BedLoop" src="https://www.bedloop.com/imatges/logo.webp" />
                                            }
                                        </a>


                                        <div className="header-hotel_grid">
                                            <div className="flex-wrap gap-2 mb-2 d-flex align-items-center">
                                                <h1 className="header-hotel_info-hotel_name">{propiedad.nombre_traducido && propiedad.nombre_traducido[lang] ? propiedad.nombre_traducido[lang] : propiedad.nombre}

                                                </h1>
                                                <div className="o-stars">
                                                    <i className="fa-solid fa-star text-categoria"></i>
                                                    <i className="fa-solid fa-star text-categoria"></i>
                                                    <i className="fa-solid fa-star text-categoria"></i>
                                                    <i className="fa-solid fa-star text-categoria"></i>
                                                    <i className="fa-solid fa-star text-categoria"></i>
                                                </div>

                                            </div>
                                            <ul className="o-list-tags">
                                                {/* <li>Junto a estació de Sants</li>
                                                <li>Terraza Chill-Out</li>*/}

                                            </ul>
                                            <div className="flex-wrap gap-2 mt-2 d-flex align-items-center d-md-block mt-md-0">
                                                <a className="text-xxs d-flex align-items-center mb-md-2">
                                                    <i className="fa-solid fa-location-dot"></i>{" "}
                                                    <span className="d-none d-md-inline"> {propiedad.calle} </span>
                                                </a>
                                                <div className="gap-2 d-flex align-items-center gap-md-3 mb-md-2 me-auto me-md-0">
                                                    <a className="text-xxs d-flex align-items-center" href={`tel: ${config.telefono_fiscal}`}>

                                                        <i className="fa-solid fa-phone"></i>{" "}
                                                        <em className="d-none d-md-inline">{config.telefono_fiscal}</em>
                                                    </a>
                                                    <a className="text-xxs d-flex align-items-center" href={`mailto:${config.email_fiscal}`}>
                                                        <i className="fa-solid fa-at"></i>{" "}
                                                        <em className="d-none d-md-inline">{config.email_fiscal}</em>
                                                    </a>
                                                </div>
                                                <div className="gap-1 text-xxs d-flex align-items-center text-primary">
                                                    <strong className="fw-semibold">5/5</strong>
                                                    <tripadvisor-bubble>
                                                        <div className="d-flex align-items-center">
                                                            <span className="o-rating full"></span>
                                                            <span className="o-rating full"></span>
                                                            <span className="o-rating full"></span>
                                                            <span className="o-rating full"></span>
                                                            <span className="o-rating full"></span>

                                                        </div>
                                                    </tripadvisor-bubble>
                                                    <span>{comentarios.length >= 1 ? comentarios.length : 1} {t("reseñas")}</span>

                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </app-hotel-top>


                    </div>
                </header >
            </header >
        </>
    );
}

export default HeaderProp;
